import { gql } from '@apollo/client'

export const UPDATE_PERSON_PHONE = gql`
  mutation UpdatePersonPhone($payload: UpdatePersonPhonePayload) {
    updatePersonPhone(payload: $payload) {
      id
      is_valid
    }
  }
`
export const UPDATE_PERSON_EMAIL = gql`
  mutation UpdatePersonEmail($payload: UpdatePersonEmailPayload) {
    updatePersonEmail(payload: $payload) {
      id
    }
  }
`

export const UPDATE_PERSON_LANGUAGE = gql`
  mutation UpdatePersonLanguage($payload: PersonLanguagePayload) {
    updatePersonLanguage(payload: $payload) {
      id
    }
  }
`
